import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@centraoneplus/ui';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { KeyboardShortcutsProvider } from '@components/KeyboardShortcuts';
import { initializeTheme } from '@stores/themeStore';
import { installEscapeToClose } from '@/lib/escapeToClose';
import App from './App';
import { queryClient } from '@/lib/queryClient';
import './styles/index.css';
// Loaded after index.css so the Ivory & Brass overrides of .btn/.card/.input/
// .badge cascade last. A CSS "@import" after the @tailwind lines is silently
// dropped by Vite ('@import must precede all other statements').
import './styles/centraone-theme.css';

// Paint the stored application theme and light/dark choice before the first
// render, so a themed user never sees a frame of the default palette.
initializeTheme();
installEscapeToClose();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider position="top-right" maxToasts={5}>
            <KeyboardShortcutsProvider>
              <App />
            </KeyboardShortcutsProvider>
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
